var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Map Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-V2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-240.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-icon",
    transform: "translate(240.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0.335 C11.169908,0.335 13.665,2.66375251 13.665,6.25 C13.665,8.80670766 11.5919274,12.1927262 8.48155172,15.4586207 L8.48155172,15.4586207 L8,15.96425 L7.22992114,15.1521201 C4.28053003,11.9819099 2.335,8.72681055 2.335,6.25 C2.335,2.66375251 4.83009198,0.335 8,0.335 Z M8,1.665 C5.54490802,1.665 3.665,3.41958082 3.665,6.25 C3.665,8.22383262 5.35131213,11.1054865 7.93454972,13.9530284 L7.93454972,13.9530284 L8,14.024 L8.32944989,13.658372 C10.6760683,11.0060648 12.221614,8.35234333 12.329017,6.45738932 L12.329017,6.45738932 L12.335,6.25 C12.335,3.41958082 10.455092,1.665 8,1.665 Z M8,3.835 C9.33376767,3.835 10.415,4.91623233 10.415,6.25 C10.415,7.58376767 9.33376767,8.665 8,8.665 C6.66623233,8.665 5.585,7.58376767 5.585,6.25 C5.585,4.91623233 6.66623233,3.835 8,3.835 Z M8,5.165 C7.40077105,5.165 6.915,5.65077105 6.915,6.25 C6.915,6.84922895 7.40077105,7.335 8,7.335 C8.59922895,7.335 9.085,6.84922895 9.085,6.25 C9.085,5.65077105 8.59922895,5.165 8,5.165 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.a171e986.svg";
export { ForwardRef as ReactComponent };